import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, mergeMap, tap } from 'rxjs/operators';
import { DesignAdapter } from '../../adapters/design.adapter';
import {
  loadDesign,
  loadDesignFailure,
  loadDesignSuccess,
  updateDesign,
  updateDesignFailure,
  updateDesignSuccess,
} from './design.actions';

@Injectable()
export class DesignEffects {
  private readonly actions$ = inject(Actions);
  private readonly designAdapter = inject(DesignAdapter);
  
  loadDesign$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadDesign),
      exhaustMap(() =>
        this.designAdapter.getDesign().pipe(
          map((design) => loadDesignSuccess({ design })),
          catchError((error) => {
            return of(loadDesignFailure({ error }));
          })
        )
      )
    )
  );

  updateDesign$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateDesign),
      mergeMap((props) =>
        this.designAdapter.editDesign(props.design).pipe(
          map(() => updateDesignSuccess({ design: props.design })),
          catchError((error) => {
            return of(updateDesignFailure({ error }));
          })
        )
      )
    )
  );

  loadDesignFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadDesignFailure),
        tap((action) => {
          // Todo: Add proper error handling. Maybe with a toasty?
          //alert(action.error.message);
        })
      ),
    { dispatch: false }
  );
}
